import React from 'react';
import PropTypes from 'prop-types';
import './modal-core-content.scss';

/**
 * Modal Core Content Details
 * @returns JSX Element
 */
const ModalCoreContent = ({ data, isLoading }) => {
  const content =
    data &&
    data.map((item, i) => {
      if (item?.custom) return item.custom;
      return (
        <div key={i} className="modal-core-content__item">
          <div className="modal-core-content__title">{item.key}</div>
          <div className={'modal-core-content__value'}>
            {item.key === 'Status' && (
              <div
                className={
                  item.value === 'Account OK'
                    ? 'modal-status-orb-positive'
                    : 'modal-status-orb-negative'
                }
              />
            )}
            {item.value && item.value != '' && item.value != null
              ? item.value
              : '-'}
          </div>
        </div>
      );
    });

  return (
    <div className={'modal-core-content'}>
      {isLoading ? (
        <div className="modal-core-content__loading">Loading...</div>
      ) : (
        content
      )}
    </div>
  );
};

ModalCoreContent.propTypes = {
  data: PropTypes.array,
  setclass: PropTypes.string,
};

export default ModalCoreContent;
